// 创建文件en/index.js
const en = {
    "my": "میرا",
    "today": "آج",
    "this_week": "اس ہفتے",
    "this_month": "اس مہینے",
    "last_month": "پچھلے مہینے",
    "this_year": "اس سال",
    "number_of_people": "افراد کی تعداد",
    "amount": "رقم",
    "enter_username_id_to_search": "تلاش کرنے کے لیے صارف نام آئی ڈی درج کریں",
    "team_list": "ٹیم کی فہرست",
    "Agent.Center": "ایجنٹ سینٹر",
    "registration_time": "رجسٹریشن کی تاریخ",
    "selling_face_value": "فروخت کی قیمت",
    "click_for_details": "تفصیلات کے لیے کلک کریں",
    "agent_login": "ایجنٹ لاگ ان",
    "SignOut": "اکاؤنٹ حذف کریں",
    "Contact us": "ہم سے رابطہ کریں",
    "Download our app": "ہمارا ایپ ڈاؤن لوڈ کریں",
    "Download it from": "یہاں سے ڈاؤن لوڈ کریں",
    "About Us": "ہمارے بارے میں",
    "Gobuy USA was founded in 2012": "گو بائی یو ایس اے کی بنیاد 2012 میں رکھی گئی تھی",
    "Customer service": "کسٹمر سروس",
    "frequently asked question": "اکثر پوچھے جانے والے سوالات",
    "Return and exchange policy": "واپسی اور تبادلے کی پالیسی",
    "Shipping and distribution": "شپنگ اور تقسیم",
    "Contact us by email": "ای میل کے ذریعے ہم سے رابطہ کریں",
    "Privacy Policy and Terms of Use": "رازداری کی پالیسی اور استعمال کی شرائط",
    "Privacy Policy": "رازداری کی پالیسی",
    "Terms of use": "استعمال کی شرائط",
    "Upload credentials": "اسناد اپ لوڈ کریں",
    "The withdrawal is being processed": "واپسی پر کارروائی ہو رہی ہے",
    "Cause of failure": "ناکامی کی وجہ",
    "Your shopping cart is still empty": "آپ کی خریداری کی ٹوکری ابھی بھی خالی ہے",
    "Log in to view the items in your cart": "اپنی ٹوکری میں موجود اشیاء دیکھنے کے لیے لاگ ان کریں",
    "Browse around": "براؤز کریں",
    "Account correlation": "اکاؤنٹ تعلق",
    "Order management": "آرڈر مینجمنٹ",
    "Payment method": "ادائیگی کا طریقہ",
    "Collection address": "کلیکشن پتہ",
    "Gobuy GIFT CARD": "گو بائی گفٹ کارڈ",
    "High Priced Recycling": "اعلی قیمت کی ری سائیکلنگ",
    "Data": "ڈیٹا",
    "congratulations": "مبارک ہو",
    "Obtain": "حاصل کریں",
    "ThankYouForParticipating": "شرکت کے لیے شکریہ",
    "Home": "ہوم",
    "Category": "زمرہ",
    "Search": "تلاش کریں",
    "ShoppingCart": "خریداری کی ٹوکری",
    "Mine": "میرا",
    "MyCommission": "میرا کمیشن",
    "Gross income": "کل آمدنی",
    "Direct commission": "براہ راست کمیشن",
    "Indirect commission": "بالواسطہ کمیشن",
    "Transfer to wallet": "والٹ میں منتقل کریں",
    "Tip: The transfer amount must be greater than 10USDT": "ٹپ: منتقلی کی رقم 10USDT سے زیادہ ہونی چاہیے",
    "transfer": "منتقل کریں",
    "commission": "کمیشن",
    "Please enter": "براہ کرم درج کریں",
    "Team Commission": "ٹیم کمیشن ",

    "EnterSearchContent": "تلاش کا مواد درج کریں",
    "Recent searches": "حالیہ تلاشیں",
    "popular searches": "مشہور تلاشیں",
    "Please search": "براہ کرم تلاش کریں",
    "orderSearch": "تلاش کرنے کے لیے آرڈر یا پروڈکٹ کا نام درج کریں",
    "Language selection": "زبان کا انتخاب",
    "Brand": "برانڈ",
    "Collect": "جمع کریں",
    "Manage": "انتظام کریں",
    "Order": "آرڈر",
    "Wallet": "والٹ",
    "BlindBox": "بلائنڈ باکس",
    "MenuGiftCard": "گفٹ کارڈ",
    "HotSale": "تازہ ترین خبریں گرم فروخت میں ہیں...",
    "TodaysOffer": "پلیٹ فارم کی پسند",
    "Phone": "فون",
    "Smart Watch": "سمارٹ واچ",
    "Smart bracelet": "سمارٹ بریسلٹ",
    "home.gobuy.title": "ایک بڑا سرپرائز حاصل کریں",
    "home.gobuy.periods": "بلائنڈ باکس راؤنڈ",
    "home.gobuy.freeze": "الٹی گنتی میں شامل ہوں",
    "home.gobuy.drawing": "الٹی گنتی شروع کریں",
    "home.gobuy.buy": "شرکت کریں",
    "home.gobuy.isbuy": "شرکت کی گئی",
    "home.gobuy.jackpot": "بونس پول",
    "Purse": "پرس",
    "Box": "بکس",
    "GetAPrize": "انعام حاصل کریں",
    "Discount": "رعایت",
    "when": "جب",
    "points": "پوائنٹس",
    "seconds": "سیکنڈ",
    "MessageBox.Tips": "ٹپس",
    "MessageBox.Confirm": "تصدیق کریں",
    "MessageBox.Cancel": "منسوخ کریں",
    "MessageBox.buy.box": "کیا آپ واقعی اس بلائنڈ باکس کو خریدنا چاہتے ہیں؟",
    "succ": "کامیابی",
    "err": "غلطی",
    "box.succeeds": "خریداری کامیاب ہوتی ہے",
    "box.frozen": "پہلے ہی شرکت کی گئی",
    "box.issue": "آپ فی شمارہ صرف ایک بلائنڈ باکس خرید سکتے ہیں",
    "filter": "فلٹر",
    "sales": "فروخت",
    "selfOP": "خود چلائی جانے والی",
    "noMore": "مزید نہیں",
    "brand": "برانڈ",
    "confirm": "تصدیق کریں",
    "reset": "ری سیٹ",
    "ComSor": "جامع ترتیب",
    "MostPop": "سب سے زیادہ مقبول",
    "HighLow": "قیمت زیادہ سے کم",
    "LowHigh": "قیمت کم سے زیادہ",
    "SalVol": "فروخت کی مقدار",
    "NewArr": "نئے آنے والے",
    "cart.cart": "خریداری کی ٹوکری",
    "cart.edit": "ترمیم کریں",
    "cart.done": "مکمل",
    "home.cart.voucher": "کوپن حاصل کریں",
    "home.cart.outstock": "اسٹاک سے باہر",
    "home.cart.offshelf": "شیلف سے ہٹا دیا گیا",
    "Only": "صرف",
    "left": "بائیں",
    "Promotion": "تشہیر",
    "cart.all": "سبھی کا انتخاب کریں",
    "cart.total": "کل",
    "cart.delete": "حذف کریں",
    "cart.checkout": "چیک آؤٹ",
    "Direct": "براہ راست",
    "Indirect": "بالواسطہ",
    "MyOrders": "میرے آرڈر",
    "ViewAll": "سبھی دیکھیں",
    "Unpaid": "غیر ادا شدہ",
    "ToShip": "بھیجنے کے لیے",
    "ToReceive": "حصول کے لیے",
    "ToReview": "جائزہ لینے کے لیے",
    "MyBlindBox": "بلائنڈ باکس کی فہرست",
    "WaitingDraw": "ڈرا کے انتظار میں",
    "Opened": "کھلا (اٹھائیں/واپس کریں)",
    "After sale": "فروخت کے بعد",
    "GiftCard": "گفٹ کارڈ کی فہرست",
    "RecycleGiftCard": "گفٹ کارڈ کی ری سائیکلنگ",
    "Verifying": "تصدیق کے تحت",
    "Rebuying": "دوبارہ خریداری جاری ہے",
    "Repurchased": "ادائیگی زیر التواء",
    "Paid": "ادائیگی کی گئی",
    "CommonTools": "عام اوزار",
    "MyWallet": "میرا والٹ",
    "VirtualOrders": "ورچوئل آرڈر",
    "Refunds": "واپسی",
    "MyFriends": "میرے دوست",
    "ChatList": "چیٹ کی فہرست",
    "RealNameVerification": "حقیقی نام کی تصدیق",
    "MyFavorites": "میرے پسندیدہ",
    "Addresses": "پتے",
    "MyReviews": "میری جائزے",
    "BrowsingHistory": "براؤزنگ",
    "Promotions": "پروموشنز",
    "StoreManagement": "اسٹور مینجمنٹ",
    "BecomeASeller": "بیچنے والا بنیں",
    "SearchPlaceholder": "تلاش کرنے کے لیے آرڈر آئٹم کا نام درج کریں",
    "OrderNo": "آرڈر نمبر",
    "items": "اشیاء",
    "ShippingFee": "شپنگ فیس",
    "Refund in Progress": "واپسی جاری ہے",
    "Cancel Order": "آرڈر منسوخ کریں",
    "Refund": "واپسی",
    "Track Shipping": "شپنگ کو ٹریک کریں",
    "Confirm Receipt": "رسید کی تصدیق کریں",
    "Evaluate": "جائزہ لیں",
    "Delete": "حذف کریں",
    "Pay": "ادائیگی کریں",
    "MessageBox.delete.order": "کیا آپ واقعی اس آرڈر کو حذف کرنا چاہتے ہیں؟",
    "MessageBox.cancel.order": "کیا آپ واقعی اس آرڈر کو منسوخ کرنا چاہتے ہیں؟",
    "MessageBox.receive.order": "کیا یہ آرڈر موصول ہوا ہے؟",
    "Order Details": "آرڈر کی تفصیلات",
    "Pickup Code": "پک اپ کوڈ",
    "Complaint": "شکایت",
    "After-Sales": "فروخت کے بعد",
    "Gift": "تحفہ",
    "Order Date": "آرڈر کی تاریخ",
    "Used voucher worth": "استعمال شدہ واؤچر کی قیمت",
    "CNY": "CNY",
    "Payment Method": "ادائیگی کا طریقہ",
    "Total Product Amount": "کل مصنوعات کی رقم",
    "Shipping Fee": "شپنگ فیس",
    "Amount Paid": "ادا شدہ رقم",
    "Return": "واپسی",
    "Pending Draw": "ڈرا زیر التواء",
    "Pending Unboxing": "ان باکسنگ زیر التواء",
    "Unboxed": "ان باکسڈ",
    "Collected": "جمع",
    "Recycled": "ری سائیکل کیا گیا",
    "Unknown": "نامعلوم",
    "Claim": "دعوی کریں",
    "Recycle": "ری سائیکل کریں",
    "Unbox": "ان باکس کریں",
    "MessageBox.recycle.box": "کیا آپ واقعی اس راز کے باکس کو ری سائیکل کرنا چاہتے ہیں؟",
    "Mystery Box Details": "راز کے باکس کی تفصیلات",
    "Unopened": "کھلا نہیں",
    "box.opened": "کھلا نہیں",
    "Claimed": "دعویدار",
    "Confirm Claim": "دعوی کی تصدیق کریں",
    "MessageBox.pick.box": "کیا آپ واقعی اس بلائنڈ باکس کو اٹھانا چاہتے ہیں؟",
    "Please add address": "براہ کرم پتہ شامل کریں",
    "Face Value Total": "کل چہرہ قیمت",
    "Gift Card Details": "گفٹ کارڈ کی تفصیلات",
    "Card number": "کارڈ نمبر",
    "Activation code": "فعال کاری کوڈ",
    "Actual recovery price": "حقیقی بحالی کی قیمت",
    "Gift Card Recycling": "گفٹ کارڈ کی ری سائیکلنگ",
    "Confirm Recycling": "ری سائیکلنگ کی تصدیق کریں",
    "Please enter the card number": "براہ کرم کارڈ نمبر درج کریں",
    "Please enter the activation code": "براہ کرم فعال کاری کوڈ درج کریں",
    "MessageBox.recycle.gift": "کیا آپ واقعی اس گفٹ کارڈ کو ری سائیکل کرنا چاہتے ہیں؟",
    "My Wallet": "میرا والٹ",
    "Available Balance": "دستیاب بیلنس",
    'Gift Balance': "تحفے کا بیلنس",
    'All': "سب",
    "Frozen Funds": "منجمد فنڈز",
    "Recharge": "ٹاپ اپ",
    "can": "کر سکتے ہیں",
    "Withdraw": "واپس لیں",
    "Withdrawal Accounts": "واپسی کے اکاؤنٹس",
    "Recharge Details": "ریچارج کی تفصیلات",
    "Recharge Order No.": "ریچارج آرڈر نمبر",
    "Recharge Amount": "ریچارج کی رقم",
    "Creation Time": "تخلیق کا وقت",
    "MessageBox.recharge.pop": "براہ کرم ریچارج کی رقم درج کریں",
    "payment": "ادائیگی",
    "Order submitted successfully, please select payment method": "آرڈر کامیابی کے ساتھ جمع کرایا گیا، براہ کرم ادائیگی کا طریقہ منتخب کریں",
    "Rechargeable card": "ریچارج کارڈ",
    "Please enter a hash": "براہ کرم ایک ہیش درج کریں",
    "Immediate payment": "فوری ادائیگی",
    "Wait for the file to load": "فائل کے لوڈ ہونے کا انتظار کریں",
    "Withdrawal Details": "واپسی کی تفصیلات",
    "Withdrawal Amount": "واپسی کی رقم",
    "Application Time": "درخواست کا وقت",
    "New Application": "نئی درخواست",
    "Payment Password": "ادائیگی کا پاس ورڈ",
    "New Payment Password": "نیا ادائیگی کا پاس ورڈ",
    "Recipient Information": "وصول کنندہ کی معلومات",
    "Submit": "جمع کریں",
    "Add Recipient Account First": "پہلے وصول کنندہ اکاؤنٹ شامل کریں",
    "Please bind your mobile phone or email first": "براہ کرم پہلے اپنا موبائل فون یا ای میل باندھیں",
    "Account Settings": "اکاؤنٹ کی ترتیبات",
    "Change Login Password": "لاگ ان پاس ورڈ تبدیل کریں",
    "Change Payment Password": "ادائیگی کا پاس ورڈ تبدیل کریں",
    "Log Out": "لاگ آؤٹ",
    "Mobile": "موبائل",
    "Verification Code": "تصدیقی کوڈ",
    "Email": "ای میل",
    "Old Password": "پرانا پاس ورڈ",
    "New Password": "نیا پاس ورڈ",
    "Confirm Password": "پاس ورڈ کی تصدیق کریں",
    "Modify": "ترمیم کریں",
    "Bind": "باندھیں",
    " Mobile": " موبائل",
    " Email": " ای میل",
    "Fund Details": "ریکارڈ کی تاریخ",
    "Withdrawal Account": "واپسی کا اکاؤنٹ",
    "Account Type": "اکاؤنٹ کی قسم",
    "USDT Address (opBNB)": "USDT-opBNB",
    "Edit": "ترمیم کریں",
    "Add New": "نیا شامل کریں",
    "MessageBox.delete.bank": "کیا آپ واقعی اس واپسی اکاؤنٹ کو حذف کرنا چاہتے ہیں؟",
    "Login": "لاگ ان",
    "Sign Up": "سائن اپ",
    "Normal Login": "معمولی لاگ ان",
    "Username / Email / Phone Number": "صارف نام / ای میل",
    "Enter Phone Number": "فون نمبر درج کریں",
    "Enter Email": "ای میل درج کریں",
    "Enter SMS Code": "ایس ایم ایس کوڈ درج کریں",
    "Enter Password": "پاس ورڈ درج کریں",
    "enter_login_password_for_verification": "براہ کرم تصدیق کے لیے اپنا لاگ ان پاس ورڈ درج کریں",
    "Forgot Password": "پاس ورڈ بھول گئے",
    "Third-party Login": "تیسرے فریق کا لاگ ان",
    "Please complete the form": "براہ کرم فارم مکمل کریں",
    "WeChat": "وی چیٹ",
    "Weibo": "ویبو",
    "QQ": "کیو کیو",
    "phone login": "فون لاگ ان",
    "Login Expired": "لاگ ان ختم ہو چکا ہے",
    "Please enter your phone number first": "براہ کرم پہلے اپنا فون نمبر درج کریں",
    "Please enter your username/email/phone number": "براہ کرم اپنا صارف نام/ای میل درج کریں",
    "Please enter your password": "براہ کرم اپنا پاس ورڈ درج کریں",
    "Password must be at least 6 characters": "پاس ورڈ کم از کم 6 حروف کا ہونا چاہیے",
    "Please enter an 11-digit phone number": "براہ کرم 11-ہندسوں کا فون نمبر درج کریں",
    "Please wait for the file to finish loading": "براہ کرم فائل کے لوڈ ہونے کا انتظار کریں",
    "send": "بھیجیں",
    "signUpTips": "آپ کے ذاتی ڈیٹا کا استعمال آپ کے تجربے کی حمایت کے لیے کیا جائے گا، آپ کے اکاؤنٹ تک رسائی کے انتظام کے لیے، اور ہماری رازداری کی پالیسی میں بیان کردہ دیگر مقاصد کے لیے۔",
    "Referrer": "حوالہ دہندہ",
    "Invitation code": "دعوت کا کوڈ",
    "Invite friends": "دوستوں کو مدعو کریں",
    "Username": "صارف نام",
    "Full Name": "پورا نام",
    "Set Password": "پاس ورڈ سیٹ کریں",
    "Change password": "پاس ورڈ تبدیل کریں",
    "Phone Number": "فون نمبر",
    "Username: 3-25 chars, letters & numbers": "صارف نام: 3-25 حروف، حروف اور نمبر",
    "6-20 digits/letters/symbols": "6-20 ہندسے/حروف/علامات",
    "By clicking sign up, you agree to": "سائن اپ پر کلک کرنے سے آپ اتفاق کرتے ہیں",
    "User Agreement": "صارف کا معاہدہ",
    "Please check the user agreement": "براہ کرم صارف معاہدے کو چیک کریں",
    "Please enter a username with 3-25 characters": "براہ کرم 3-25 حروف کا صارف نام درج کریں",
    "Enter SMS Verification Code": "ایس ایم ایس تصدیقی کوڈ درج کریں",
    "Please enter your phone number": "براہ کرم اپنا فون نمبر درج کریں",
    "Please enter the verification code": "براہ کرم تصدیقی کوڈ درج کریں",
    "Please enter a 6-digit verification code": "براہ کرم 6 ہندسوں کا تصدیقی کوڈ درج کریں",
    "Please enter a password with 6-20 characters": "براہ کرم 6-20 حروف کا پاس ورڈ درج کریں",
    "Please enter the confirm password": "براہ کرم پاس ورڈ کی تصدیق درج کریں",
    "The confirm password does not match the entered password": "تصدیق کا پاس ورڈ درج کردہ پاس ورڈ سے میل نہیں کھاتا",
    "Password Recovery": "پاس ورڈ کی بازیابی",
    "Forget.email.tips": "اگر آپ کا اکاؤنٹ ابھی تک کسی ای میل نمبر سے منسلک نہیں ہے، تو براہ کرم اپنا پاس ورڈ بازیافت کرنے کے لیے پلیٹ فارم ایڈمنسٹریٹر سے رابطہ کریں۔",
    "Notification Message": "اطلاع کا پیغام",
    "Direct Message": "براہ راست پیغام",
    "System Message": "سسٹم پیغام",
    "Leave a Message": "ایک پیغام چھوڑیں",
    "Delivery Address": "ترسیل کا پتہ",
    "The store is no longer valid, please edit the delivery address again": "اسٹور اب درست نہیں ہے، براہ کرم ترسیل کا پتہ دوبارہ ترمیم کریں",
    "Default address": "پہلے سے طے شدہ پتہ",
    "Add address": "پتہ شامل کریں",
    "Edit address": "پتہ ترمیم کریں",
    "MessageBox.delete.address": "کیا آپ واقعی اس پتے کو حذف کرنا چاہتے ہیں؟",
    "name": "نام",
    "phone": "فون",
    "district": "ضلع",
    "address": "پتہ",
    "default address": "پہلے سے طے شدہ پتہ",
    "save and use": "محفوظ کریں اور استعمال کریں",
    "save": "محفوظ کریں",
    "Please select a region": "براہ کرم ایک علاقہ منتخب کریں",
    "Please fill in the recipient name": "براہ کرم وصول کنندہ کا نام بھریں",
    "Name must be 2-15 characters": "نام 2-15 حروف کا ہونا چاہیے",
    "Please fill in the mobile phone number": "براہ کرم موبائل فون نمبر بھریں",
    "Please select your location": "براہ کرم اپنا مقام منتخب کریں",
    "Please fill in the detailed address": "براہ کرم تفصیلی پتہ بھریں",
    "Browsing History": "براؤزنگ کی تاریخ",
    "Clear browsing history": "تاریخ صاف کریں",
    "Promotion member": "پروموشن ممبر",
    "PromotionPoster": "پروموشن پوسٹر",
    "MemberName": "ممبر کا نام",
    "MyAssets": "میری اثاثے",
    "DistributedAmount": "تقسیم شدہ رقم",
    "NumberOfDistributedProducts": "تقسیم شدہ مصنوعات کی تعداد",
    "DistributedProductAmount": "تقسیم شدہ مصنوعات کی رقم",
    "MyTeam": "میری ٹیم",
    "LevelOneMembers": "سطح 1 کے ممبران",
    "LevelTwoMembers": "سطح 2 کے ممبران",
    "PromotionMembers": "پروموشن ممبران",
    "PromotionPerformance": "پروموشن کارکردگی",
    "ViewPromotionLink": "پروموشن لنک دیکھنے کے لیے کلک کریں",
    "PromoteViaWeChatQRCode": "وی چیٹ کیو آر کوڈ کے ذریعے پروموٹ کریں",
    "Copy": "کاپی کریں",
    "BrowserNotSupportedCopyManually": "آپ کا براؤزر براہ راست کاپی کی حمایت نہیں کرتا؛ براہ کرم دستی طور پر کاپی کریں",
    "GiftCardRecoveryTotal": "گفٹ کارڈ کی بازیابی کا مجموعی",
    "TodaysGiftCardRecoveryCount": "آج کی گفٹ کارڈ کی بازیابی کی گنتی",
    "RegistrationDate": "رجسٹریشن کی تاریخ",
    "LastLogin": "آخری لاگ ان",
    "Promotion Commission": "پروموشن کمیشن",
    "Personal Info": "ذاتی معلومات",
    "Nickname": "عرفیت",
    "Birthdate": "پیدائش کی تاریخ",
    "Save": "محفوظ کریں",
    "CropImage": "تصویر کاٹیں",
    "UseImage": "تصویر استعمال کریں",
    "Off": "بند",
    "Sold": "فروخت ہو گیا",
    "Product": "مصنوعات",
    "Comment": "تبصرہ",
    "Details": "تفصیلات",
    "ReportViolation": "رپورٹ کریں",
    "Cart": "کارٹ",
    "ChatMessages": "چیٹ پیغامات",
    "MyShop": "میری دکان",
    "MerchantLogin": "مرچنٹ لاگ ان",
    "Share": "شیئر کریں",
    "ShareTo": "اس پر شیئر کریں",
    "Poster": "پوسٹر",
    "Follow": "فالو کریں",
    "Unfollow": "انفالو کریں",
    "PleaseSelectQuantityAndCategory": "براہ کرم مقدار اور زمرہ منتخب کریں۔",
    "SelectedWithQuantity1": "منتخب {specification}, مقدار {number}.",
    "SelectedQuantity1": "منتخب مقدار {number}.",
    "SelectedWithQuantity2": "منتخب {specification}, مقدار {number}.",
    "Add to cart": "کارٹ میں شامل کریں",
    "Buy now": "ابھی خریدیں",
    "Stock": "اسٹاک",
    "Pieces": " ٹکڑے",
    "Quantity": "مقدار",
    "All": "سب",
    "Good": "اچھی جائزہ",
    "Medium": "درمیانی جائزہ",
    "Bad": "خراب جائزہ",
    "Product review": "مصنوعات کا جائزہ",
    "anonymous": "گمنام",
    "noReviewInfo": "کوئی جائزہ معلومات فراہم نہیں کی گئی",
    "Shop Owners Response": "دکان کے مالک کا جواب",
    "This product has no current reviews": "اس پروڈکٹ کی کوئی موجودہ جائزے نہیں ہیں",
    "Product details": "مصنوعات کی تفصیلات",
    "shop": "دکان",
    "customerService": "کسٹمر سروس",
    "shoppingCart": "خریداری کی ٹوکری",
    "addToCart": "کارٹ میں شامل کریں",
    "buyNow": "ابھی خریدیں",
    "outOfStock": "منتخب پروڈکٹ اس وقت اسٹاک میں نہیں ہے، ہمیں افسوس ہے!",
    "notAvailable": "منتخب پروڈکٹ اب دستیاب نہیں ہے، ہمیں افسوس ہے!",
    "Store order message": "اسٹور آرڈر پیغام",
    "Confirm the order": "آرڈر کی تصدیق کریں",
    "productAmount": "مصنوعات کی رقم",
    "discount": "رعایت",
    "shippingFee": "شپنگ فیس",
    "subtotal": "اسٹور کے لیے سب ٹوٹل",
    "Submit an order": "آرڈر جمع کریں",
    "refundAdd": "واپسی شامل کریں",
    "back": "پیچھے",
    "proofOfRefund": "واپسی کا ثبوت",
    "use": "استعمال کریں",
    "yi1": "ایک ڈالر کی خریداری",
    "yi2": "قیمت زون",
    "yi3": "زون",
    "yi4": "خریداری کے ریکارڈ",
    "yi5": "حاصل کردہ مصنوعات کے ریکارڈ",
    "yi6": "ریڈیمپشن کوڈ دیکھیں",
    "yi7": "واپسی کے لیے درخواست دیں",
    "yi8": "ریچارج",
    "yi9": "شرکت کی گئی مقدار",
    "yi10": "کل مقدار",
    "yi11": "کمی کی مقدار",
    "yi12": "ابھی خریدیں",
    "yi13": "خریداری جاری رکھیں",
    "yi14": "دیگر زون",
    "yi15": "مزید لوڈ کریں",
    "yi16": "جلد آ رہا ہے...",
    "yi17": "زون",
    "yi18": "راؤنڈ",
    "yi19": "مدت",
    "yi20": "قیمت: ",
    "yi21": "مزید لوڈ کریں",
    "yi22": "جلدی سے ادائیگی کریں -- اس پروڈکٹ کی معلومات جسے آپ خریدنا چاہتے ہیں",
    "yi23": "خریداری کی مقدار",
    "yi24": "(جتنا زیادہ آپ خریدیں گے، آپ کے پروڈکٹ حاصل کرنے کے امکانات اتنے ہی زیادہ ہوں گے!)",
    "yi25": "کل: ",
    "yi26": "ادائیگی کامیاب",
    "yi27": "ادائیگی ناکام",
    "yi28": "وجہ: ",
    "yi29": "نتائج کا اعلان ہوا",
    "yi30": "لکی کوڈ",
    "yi31": "مصنوعات کے فاتح",
    "yi32": "مبارک ہو، آپ نے اس پروڈکٹ کو جیتا",
    "yi33": "اعلان کا وقت: ",
    "yi34": "خریداری کا وقت: ",
    "yi35": "فاتح کی طرف سے خریدی گئی کل تعداد: ",
    "yi36": "خریداری کوڈ:",
    "yi37": "اٹھائیں",
    "yi38": "کیش ان",
    "yi39": "پیشگی آرڈر",
    "yi40": "خریداری",
    "yi41": "حاصل کردہ مصنوعات کے ریکارڈ",
    "yi42": "جیت کی تاریخ: ",
    "hunt1": "تبادلہ",
    "hunt2": "لکی ہیڈ سٹارٹ",
    "hunt3": "ناقابل شکست",
    "hunt4": "تبادلہ کوڈ",
    "hunt5": "تبادلہ کوڈ: ",
    "hunt6": "مزید لوڈ کریں",
    "hunt7": "میں اٹھانا چاہتا ہوں",
    "hunt8": "براہ کرم تبادلہ کوڈ درج کریں",
    "hunt9": "تبادلہ قیمت فروخت کی قیمت کا 10% ہے",
    "hunt10": "مصنوعات کی فہرست",
    "hunt11": "زون",
    "hunt12": "زبان",
    "hunt13": "اعلان",
    "hunt14": "نیویگیشن",
    "hunt15": "سرکاری اعلان",
    "hunt16": "خزانہ ریکارڈ",
    "hunt17": "شپنگ قواعد",
    "hunt18": "قواعد کی وضاحت",
    "hunt19": "میں تبادلہ کرنا چاہتا ہوں",
    "hunt20": "ہم سے رابطہ کریں",
    "hunt21": "ای میل",
    "hunt22": "لاٹری قواعد",
    "hunt23": "قواعد کا جائزہ",
    "hunt24": "1. نمبر الاٹمنٹ: ",
    "hunt25": "ہر 0.1 USDT کے لیے، صارفین 000001 سے شروع ہونے والی ایک لکی نمبر حاصل کرتے ہیں اور یہ اس وقت تک تقسیم کی جاتی ہے جب تک کہ ہدف کے شرکاء کی تعداد (مثلاً 1000) تک نہ پہنچ جائے۔",
    "hunt26": "2. لاٹری کی شرائط: ",
    "hunt27": "جب پروڈکٹ ہدف کے شرکاء کی تعداد (مثلاً 1000) تک پہنچ جائے تو لاٹری کا عمل شروع ہوتا ہے۔",
    "hunt28": "3. لاٹری کا وقت: ",
    "hunt29": "آخری آرڈر کی تصدیق کے بعد، قریب ترین بلاک چین وقت کا انتظار کریں جو 05، 10، 15، 25، 30، 35، 40، 45، 50، 55 یا پورے گھنٹے میں ختم ہوتا ہے۔",
    "hunt30": "4. جیتنے والے نمبر کی حساب کتاب: ",
    "hunt31": "1. بلاک ہیش سے خالص نمبر نکالیں اور کل شرکاء کی بنیاد پر ماڈیولو کی حساب کتاب کریں: جیتنے والا نمبر = (خالص نمبر % کل شرکاء) + 1",
    "hunt32": "2. حساب کتاب کا نتیجہ جیتنے والے نمبر کے مطابق ہے۔",
    "hunt33": "شرکت کا مرحلہ",
    "hunt34": "ہر 0.1 USDT کے لیے صارفین کو ایک لکی نمبر ملتا ہے۔",
    "hunt35": "جب پروڈکٹ ہدف کے شرکاء کی تعداد تک پہنچ جاتا ہے، تو نئی اندراجات کو روک دیا جاتا ہے۔",
    "hunt36": "لاٹری کا مرحلہ",
    "hunt37": "آخری آرڈر کے وقت کو درستگی سے ریکارڈ کریں (مثلاً 15:47:23)۔",
    "hunt38": "مناسب وقت کے خاتمے کے ساتھ قریب ترین بلاک چین بلاک کے پیدا ہونے کا انتظار کریں:",
    "hunt39": "بلاک چین وقت 05، 10، 15، 25، 30، 35، 40، 45، 50، 55، یا پورے گھنٹے کے اختتام کے ساتھ ختم ہوتا ہے (مثلاً 15:50:00)۔",
    "hunt40": "شرائط کے ساتھ میل کھاتے ہوئے بلاک ہیش کو حاصل کریں۔",
    "hunt41": "جیتنے کا مرحلہ",
    "hunt42": "بلاک ہیش سے خالص نمبر نکالیں۔",
    "hunt43": "مثال کے طور پر بلاک ہیش: 0000000000000000000a16b6f44536e521000000adbcf3f4b2ec018ffabcd123",
    "hunt44": "نکالی گئی خالص نمبر: 16644536521000000342018123",
    "hunt45": "ماڈیولو کل شرکاء: ",
    "hunt46": "جیتنے والا نمبر",
    "hunt47": "= (نکالی گئی نمبر % کل شرکاء) + 1 ",
    "hunt48": "اگر نکالی گئی نمبر 16644536521000000342018123 ہے، اور کل شرکاء 1000 ہیں: ",
    "hunt49": "= (16644536521000000342018123 % 1000) + 1 = 123 + 1 = 124",
    "hunt50": "نتائج کو عوامی بنائیں",
    "hunt51": "پلیٹ فارم جیتنے والے نمبر اور متعلقہ صارف کی معلومات کا اعلان کرتا ہے۔",
    "hunt52": "پوری حساب کتاب کے عمل کو بھی فراہم کرتا ہے (آرڈر کا وقت، استعمال شدہ بلاک ہیش، نکالی گئی نمبر، اور جیتنے والے نمبر کی حساب کتاب کا فارمولا)۔",
    "hunt53": "فوائد",
    "hunt54": "1. انصاف",
    "hunt55": "عوامی بلاک چین ہیش قدروں کا استعمال کرکے لاٹری کے نتائج غیر متوقع اور چھیڑ چھاڑ سے پاک ہوتے ہیں۔",
    "hunt56": "2. شفافیت",
    "hunt57": "صارفین ہیش قدروں اور نمبر الاٹمنٹ کے عمل کی جانچ کر سکتے ہیں۔",
    "hunt58": "3. اعلی کارکردگی",
    "hunt59": "نتائج کو مناسب بلاک کی انتظار کرکے تیزی سے طے کیا جا سکتا ہے۔",
    "hunt60": "اعلان کی تفصیلات",
    "hunt61": "خریداری کی رقم: ",
    "hunt62": "اشیاء",
    "hunt63": "خریداری کوڈز کے لیے کلک کریں",
    "hunt64": "خریداری کوڈ: ",
    "hunt65": "قواعد کی وضاحت",
    "hunt66": "آرڈرز کے بارے میں",
    "hunt67": "اس بات کو یقینی بنانے کے لیے کہ آپ اپنے پروڈکٹس کو بروقت وصول کریں، 4 بجے سے پہلے کے آرڈرز اسی دن XX کورئیر یا XX کورئیر کے ذریعے بھیجے جائیں گے۔ تیز تر شپنگ کے لیے، براہ کرم قیمت کے فرق کی ادائیگی کے لیے کسٹمر سروس سے رابطہ کریں۔ دیگر کورئیر سروسز فی الحال سپورٹ نہیں کی جاتیں۔",
    "hunt68": "رسیدوں کے بارے میں",
    "hunt69": "فروخت کیے گئے تمام پروڈکٹس کے لیے الیکٹرانک رسیدیں جاری کی جا سکتی ہیں۔ آپ اپنے آرڈر کے ذریعے کسٹمر سروس سے رابطہ کر سکتے ہیں اور رسید کی معلومات فراہم کر سکتے ہیں۔ عام طور پر، رسیدیں 1-3 دنوں کے اندر جاری کی جائیں گی۔ اگر یہ چھٹیوں کے دوران ہے، تو جاری کرنے میں تاخیر ہو گی۔",
    "hunt70": "لکی بائی",
    "new1": "مثال",
    "new2": "پروڈکٹ کو 1,000 شرکاء کی ضرورت ہے۔ آخری آرڈر کا وقت 15:47:23 ہے۔\nڈرا وقت کے ساتھ میل کھاتا ہے سب سے حالیہ بلاک وقت 15:50:00 ہے",
    "new3": "بلاک ہیش ویلیو ہے:",
    "new4": "ہیش ویلیو سے خالص اعداد و شمار نکالنا:",
    "new5": "جیتنے والے نمبر کی حساب کتاب:",
    "new6": "جیتنے والا نمبر",
    "new7": "جیتنے والا نمبر 124 ہے، اور متعلقہ صارف فاتح ہے۔",
    "new8": "رڈییمڈ",
    "new9": "رڈییم نہیں کیا گیا",
    "new10": "بدقسمتی سے، آپ نہیں جیتے",
    "new11": "مبارک ہو",
    "new12": "اس راؤنڈ میں آئٹم جیتا",
    "new13": "رڈیم کریں",
    "new14": "لکی خریداری",
    "new15": "آئٹم اٹھا لیا گیا",
    "new16": "کیا آپ واقعی سامان اٹھانا چاہتے ہیں؟",
    "new17": "کیا آپ واقعی رڈیم کرنا چاہتے ہیں؟",
    "copyS": "کاپی کامیاب",
    "copyE": "کاپی ناکام",
    "new18": "پروڈکٹ ڈسپلے",
    "new19": "پچھلا صفحہ",
    "new20": "اگلا صفحہ",
    "new21": "پر",
    "new22": "صفحہ",
    "new23": "تصدیق کریں",
    "new24": "قرعہ اندازی کا انتظار",
    "tool1": "ہوم",
    "tool2": "مصنوعات",
    "tool3": "خبریں",
    "tool4": "شکار کے لاگز",
    "tool5": "شپنگ",
    "tool6": "قواعد",
    "tool7": "رڈیم",
    "tool8": "رابطہ",
    "new25": "پروڈکٹ رڈیمپشن",
    "new26": "براہ کرم اپنا گو بائی صارف نام درج کریں",
    "ship1": "لاگو دائرہ کار",
    "ship2": "یہ شپنگ کے قواعد لکی بائی ای کامرس پلیٹ فارم پر موجود تمام آرڈرز پر لاگو ہوتے ہیں۔ چونکہ پلیٹ فارم صرف USDT ادائیگی قبول کرتا ہے، یہ کریڈٹ کارڈ، نقد ادائیگی، یا مال کی کٹوتی کی حمایت نہیں کرتا۔ مندرجہ ذیل قواعد اس طرح وضع کیے گئے ہیں۔",
    "ship3": "1. ریاستہائے متحدہ کے اندر شپنگ کے قواعد",
    "ship4": "ادائیگی کے طریقے",
    "ship5": "صرف USDT ادائیگی قبول کی جاتی ہے۔ کریڈٹ کارڈ اور نقد نپٹارہ معاون نہیں ہیں۔",
    "ship6": "ڈلیوری سروس پر نقد",
    "ship7": "ڈلیوری سروس پر نقد صرف ریاستہائے متحدہ کے اندر موجود صارفین کے لیے دستیاب ہے۔ شپنگ لاگت کی پیشگی ادائیگی ضروری نہیں ہے۔",
    "ship8": "شپنگ پالیسی",
    "ship9": "آرڈر کی رقم میں شپنگ لاگت شامل نہیں ہے، جسے الگ سے ادا کرنا ہوتا ہے۔",
    "ship10": "ڈلیوری کی حد",
    "ship11": "ریاستہائے متحدہ کی پوری مین لینڈ میں ڈلیوری معاون ہے۔",
    "ship12": "صارف کا نوٹس",
    "ship13": "آرڈر دینے کے بعد، صارفین کو یہ یقینی بنانا چاہیے کہ ان کی رابطہ معلومات درست ہیں۔ وصولی کے وقت صارف یا ان کے مجاز نمائندے کو مال پر دستخط کرنا ضروری ہے۔",
    "ship14": "2. ریاستہائے متحدہ سے باہر شپنگ کے قواعد",
    "ship15": "صرف USDT ادائیگی قبول کی جاتی ہے۔ کریڈٹ کارڈ اور نقد نپٹارہ معاون نہیں ہیں۔",
    "ship16": "ریاستہائے متحدہ سے باہر کے صارفین کو آرڈر ادائیگی کے بعد شپنگ لاگت کے لیے اضافی ادائیگی کرنا ضروری ہے۔",
    "ship17": "ایک بار اضافی شپنگ کی ادائیگی کی جانے پر، پلیٹ فارم شپمنٹ کی ترتیب دے گا۔",
    "ship18": "نقد پر ڈلیوری پالیسی",
    "ship19": "ڈلیوری سروس پر نقد فراہم نہیں کی جاتی۔ ریاستہائے متحدہ سے باہر کے صارفین کو آرڈر کے عمل سے پہلے شپنگ لاگت کی ادائیگی مکمل کرنا ضروری ہے۔",
    "ship20": "اضافی شپنگ لاگت کی عمل",
    "ship21": "آرڈر دینے کے بعد، پلیٹ فارم صارف کے پتے کی بنیاد پر شپنگ لاگت کا حساب لگائے گا اور صارف کو USDT کے ذریعے اضافی رقم کی ادائیگی کے لیے مطلع کرے گا۔",
    "ship22": "شپنگ کے لیے ادائیگی مکمل ہونے پر، پلیٹ فارم شپمنٹ کی ترتیب دے گا اور لاجسٹکس کی ٹریکنگ معلومات فراہم کرے گا۔",
    "ship23": "ڈلیوری تمام ممالک میں معاون ہے۔ مخصوص ڈلیوری وقت مقامی لاجسٹکس حالات پر منحصر ہے۔",
    "ship24": "صارفین کو یہ یقینی بنانا ہوگا کہ پتہ اور رابطہ کی معلومات درست ہیں۔ غلط معلومات کی وجہ سے کسی بھی ڈلیوری کی ناکامی کی ذمہ داری صارف کی ہوگی۔",
    "ship25": "منزل ملک میں کسٹم پالیسیوں کے لیے پلیٹ فارم ذمہ دار نہیں ہے۔ صارفین کو خود کسٹم کلیئرنس اور کسی بھی ممکنہ اضافی فیس کو سمجھنا اور سنبھالنا چاہیے۔",
    "ship26": "نوٹس",
    "ship27": "1. ایک بار آرڈر کامیابی سے ادا کرنے پر، اسے منسوخ یا ریفنڈ نہیں کیا جا سکتا۔ صارفین کو ادائیگی سے پہلے آرڈر کی معلومات کو احتیاط سے تصدیق کرنے کی صلاح دی جاتی ہے۔",
    "ship28": "2. لکی بائی نقل و حمل کے دوران قوت کے سبب پیدا ہونے والے مسائل کے لیے ذمہ دار نہیں ہے (جیسے قدرتی آفات یا پالیسی میں تبدیلیاں) لیکن صارفین کو انہیں حل کرنے میں مدد کرنے کی ہر ممکن کوشش کرے گا۔",
    "ship29": "3. کسی بھی سوالات کے لیے، براہ کرم ہمارے پلیٹ فارم کی کسٹمر سروس چینلز سے رابطہ کریں۔",
    "ship30": "آپ کے سمجھنے اور حمایت کے لیے شکریہ!",
    "ship31": "لکی بائی آپ کی خدمت کے لیے وقف ہے۔",
    "Original Price": "اصل قیمت",
    "Actual Payment": "حقیقی ادائیگی",
    "Balance": "بیلنس",
    "MessageBox.buy.card": "کیا آپ واقعی اس گفٹ کارڈ کو خریدنا چاہتے ہیں؟",
    "MyCard": "میرا کارڈ",
    "Please upload pictures": "براہ کرم تصاویر اپ لوڈ کریں",
    "Share audit list": "شیئر آڈٹ کی فہرست",
    "Share page": "صفحہ شیئر کریں",
    "Audit result": "آڈٹ کا نتیجہ",
    "Share to the community": "کمیونٹی میں شیئر کریں",
    "imshares1": "مرحلہ تعارف",
    "imshares2": "پہلا قدم: پروڈکٹ کو سوشل میڈیا پر شیئر کریں۔",
    "imshares3": "دوسرا قدم: پروڈکٹ کے شیئر کیے گئے صفحے کا اسکرین شاٹ لیں اور اسے GoBuy پر اپ لوڈ کریں۔",
    "Share Time": "شیئر کا وقت",
    "Audit status": "آڈٹ کی حیثیت",
    "Reason for failure": "ناکامی کی وجہ",
    "Pending approval": "منظوری زیر التواء",
    "Approved": "منظور شدہ",
    "Audit failed": "آڈٹ ناکام",
    "Url Copied": "لنک کامیابی سے کاپی ہوا، شیئر کرنے کے لیے دوبارہ ہدایت کی جا رہی ہے...",
    "Points Logs": "پوائنٹس لاگز",
    "My Points": "میرے پوائنٹس",
    "Go Excharge": "تبادلہ کے لیے جائیں",
    "Confirm points excharge": "کیا آپ واقعی تمام پوائنٹس کو بیلنس میں تبدیل کرنا چاہتے ہیں؟",
    "is not share": "آپ نے ابھی تک شیئرنگ کا کام مکمل نہیں کیا ہے",
    "is buied": "آپ نے آج پہلے ہی خریداری کر لی ہے",
    "My card": "میرا کارڈ",
    "Country/Region": "ملک/علاقہ",
    "Contact info": "رابطہ کی معلومات",
    "Please enter realname": "براہ کرم اصلی نام درج کریں",
    "Please enter Phone Number": "براہ کرم فون نمبر درج کریں",
    "Please enter State/Province/Region": "براہ کرم ریاست/صوبہ/علاقہ درج کریں",
    "Please enter City": "براہ کرم شہر درج کریں",
    "Please enter Street Address": "براہ کرم سٹریٹ ایڈریس درج کریں",
    "Please enter Postal Code": "براہ کرم پوسٹل کوڈ درج کریں",
    "lucky_draw_winning_products": "لکی بائی ڈرا میں جیتنے والے پروڈکٹس",
    "refundDescription": "واپسی کی تفصیل",
    "productQualityIssue": "مصنوعات کے معیار کا مسئلہ",
    "logisticsTransportIssue": "لاجسٹکس اور نقل و حمل کا مسئلہ",
    "sellerPlatformIssue": "بیچنے والا یا پلیٹ فارم کا مسئلہ",
    "personalReason": "ذاتی وجہ",
    "otherSpecialCases": "دیگر خاص معاملات",
    "hunt points rule": "پوائنٹس کی تفصیل",
    "hunt points rule1": "1. پوائنٹس کا حصول: خوش نصیب خریداریوں میں حصہ لینے والے صارفین ہر 0.1 امریکی ڈالر کی سرمایہ کاری پر 1 پوائنٹ حاصل کر سکتے ہیں۔",
    "hunt points rule2": "2. پوائنٹس کا تبادلہ: 1 پوائنٹ = 0.01% امریکی ڈالر",
    'Login Password': "لاگ اِن پاس ورڈ",
    "Level": "درجہ",
    
    "guide.Rewards": "انعامات کا تعارف",
    "guide.title": "نئے صارف کی رہنمائی",
    "guide.Invitation.Reward": "ایونٹ انعام",
    "guide.Order.Sharing": "آرڈر شیئرنگ",
    "guide.section1.title": "لکی بائے خریداری گائیڈ",
    "guide.section1.step1": "خریداری کا انتخاب کریں: ڈالر سیکشن میں جائیں اور اپنی مطلوبہ مصنوعات منتخب کریں۔",
    "guide.section1.step2": "مقدار منتخب کریں: حصہ لینے کے لیے خریداری کی مقدار درج کریں۔",
    "guide.section1.step3": "خریداری کی مقدار: صرف $0.1 میں 1 یونٹ خریدیں۔",
    "guide.section1.step4": "قرعہ اندازی کا انتظار کریں: سسٹم خود بخود خوش نصیب فاتح کا انتخاب کرے گا۔",
    "guide.section2.title": "بلیند باکس خریداری گائیڈ",
    "guide.section2.step1": "بلیند باکس کھولیں: بلیند باکس سیکشن میں جائیں۔",
    "guide.section2.step2": "فوری شرکت کریں: 10 ڈالر ادا کریں۔",
    "guide.section2.step3": "انعام حاصل کریں: 3 ملین ڈالر تک کی قیمت والے انعامات جیتیں۔",
    "guide.section3.title": "گفٹ کارڈ خریداری گائیڈ",
    "guide.section3.step1": "کمیونٹی میں شیئر کریں: فوری طور پر سرگرمی شیئر کریں اور معلومات اپلوڈ کریں۔",
    "guide.section3.step2": "رقم منتخب کریں: گفٹ کارڈ کی قیمت آزادانہ طور پر منتخب کریں۔",
    "guide.section3.step3": "100 گفٹ کارڈز صرف $98 میں خریدیں۔",
    "guide.section3.step4": "فوری دوبارہ خریداری: 100٪ دوبارہ خریداری، $2 کمائیں",
    "guide.tip.title": "گرم مشورہ: بہترین فوائد مت چھوڑیں",
    "guide.tip.luckyBuy": "صرف 0.1 ڈالر میں حصہ لیں، 1 سے 50,000 ڈالر کے انعامات جیتنے کا موقع!",
    "guide.tip.luckyBuy1": "ٹیم کمیشن انعام: دوستوں کو مدعو کریں اور خریداری پر 0.2% تک کمیشن حاصل کریں!",
    "guide.tip.luckyBuy2": "پوائنٹس ریڈیمپشن: ہر لکی بائ خریداری پر 1 پوائنٹ حاصل کریں، 1000 پوائنٹس = $0.1!",
    "guide.tip.example": "مثال:",
    "guide.tip.example1": "آپ نے صارف A کو مدعو کیا، A نے 1000 ڈالر کی خریداری کی → آپ کو 2 ڈالر کمیشن ملے گا۔",
    "guide.tip.example11": "A نے صارف B کو مدعو کیا، B نے 1000 ڈالر کی خریداری کی → آپ کو اضافی 1 ڈالر کمیشن ملے گا۔",
    "guide.tip.boxTitle": "بلیند باکس قرعہ اندازی",
    "guide.tip.box": "10 ڈالر میں 1 بار حصہ لیں، انعام کی قیمت 3 ملین ڈالر تک!",
    "guide.tip.cardTitle": "گفٹ کارڈ",
    "guide.tip.card": "ٹیم کمیشن: دوستوں کو مدعو کریں اور خریداری پر 0.4% تک کمیشن حاصل کریں!",
    "guide.tip.example2": "جب آپ صارف A کو $100 کا گفٹ کارڈ خریدنے کی دعوت دیتے ہیں تو آپ کو $0.4 کمیشن ملے گا۔",
    "guide.tip.example3": "اگر A صارف B کو مدعو کرتا ہے اور B $100 کا گفٹ کارڈ خریدتا ہے تو آپ کو اضافی $0.2 کمیشن ملے گا۔",
    "guide.tip.callToAction": "ابھی حصہ لیں اور اپنی قسمت کا سفر شروع کریں!",
    "guide.warning.title": "اہم ہدایات",
    "guide.warning.rule1": "کمیشن کب منسوخ ہو جائے گا؟",
    "guide.warning.answer1": "اگر سافٹ ویئر یا دیگر پلیٹ فارمز کے ذریعے کمیشن حاصل کرنے کی کوشش کی گئی تو تمام کمیشن منسوخ کر دیے جائیں گے اور اکاؤنٹ بند کر دیا جائے گا۔",
    "guide.warning.rule2": "کیا خود کو مدعو کرنے پر کمیشن ملے گا؟",
    "guide.warning.answer2": "نہیں۔ اگر دھوکہ دہی ثابت ہو گئی تو تمام کمیشن منسوخ کر دیے جائیں گے، کمیشن کی اہلیت ختم کر دی جائے گی، اور اکاؤنٹ حذف کر دیا جائے گا۔",
    "invite.title": "فائدے آ گئے ہیں | دوستوں کو مدعو کریں اور 4 بڑے انعامات جیتیں!",
    "invite.reward1.title": "انعام 1: گروپ میں مدعو کریں، آسانی سے ڈالر + گفٹ کارڈ حاصل کریں",
    "invite.reward1.item1": "ہر بار 10 نئے ممبران کو گروپ میں مدعو کریں، فوری ریڈ پیکٹ انعام حاصل کریں!",
    "invite.reward1.item2": "ساتھ ہی 1 ڈالر کا گفٹ کارڈ حاصل کریں",
    "invite.reward1.item3": "جتنا زیادہ مدعو کریں گے اتنے زیادہ انعامات! ریڈ پیکٹ فوری بھیجے جاتے ہیں، گفٹ کارڈ فوری تبدیل کیے جا سکتے ہیں!",
    "invite.reward2.title": "انعام 2: لکی بائے، آرام سے کمیشن کمائیں",
    "invite.reward2.item1": "دوست جب لکی بائے میں حصہ لیں گے تو آپ کو کمیشن ملے گا!",
    "invite.reward2.item2": "کمیشن کی کوئی حد نہیں، جتنا زیادہ خریدیں گے اتنا زیادہ کمائیں گے!",
    "invite.reward3.title": "انعام 3: گفٹ کارڈ",
    "invite.reward3.item1": "دوست جب گفٹ کارڈ خریدیں گے تو فوری کمیشن ملے گا!",
    "invite.reward3.item2": "مفت شیئر لنک، خودکار ٹریکنگ، بہت آسان:",
    "invite.reward3.item3": "لنک بھیجیں → دوست آرڈر کریں → پیسے کا انتظار کریں!",
    "invite.callToAction": "ابھی دوستوں کو گروپ میں مدعو کریں اور تمام انعامات حاصل کریں! مل کر کھیلیں اور کمائیں!",
    "share.title": "GoBuy کی جیت کا تجربہ شیئر کریں اور 1 ڈالر کا گفٹ کارڈ حاصل کریں",
    "share.subtitle": "شیئر کا عنوان",
    "share.content1": "GoBuy لکی شاپنگ کا شکریہ! ہمارے ایک ممبر نے معمولی سرمایہ کاری سے انعام جیتا اور کامیابی سے رقم نکالی!✨",
    "share.content2": "اب آپ کی باری ہے! بس اپنی جیت کا تجربہ شیئر کریں اور مفت 1 ڈالر GoBuy گفٹ کارڈ حاصل کریں! نہ چھوڑیں—آسان، انعامات بھرے اور مزیدار!",
    "share.inviteLink": "اپنا دعوتی کوڈ منسلک کریں:",
    "share.stepsTitle": "شمولیت کا طریقہ:",
    "share.step1": "لکی بائے زون میں خریداری/آرڈر کوڈ کا اسکرین شاٹ اپ لوڈ کریں",
    "share.step2": "‘مبارک ہو! آپ جیت گئے ہیں!’ کا اسکرین شاٹ اپ لوڈ کریں",
    "share.step3": "رقم نکالنے کی درخواست اور کامیاب ٹرانزیکشن کا اسکرین شاٹ اپ لوڈ کریں",
    "share.step4": "مندرجہ بالا مراحل مکمل کرنے کے بعد، اپنے سوشل میڈیا شیئرنگ کا اسکرین شاٹ کسٹمر سپورٹ کو بھیج کر تصدیق کروائیں",
    "share.email": "کسٹمر سپورٹ ای میل:",
    "share.footer": "خوش قسمتی آپ کے ساتھ ہو—کھیل جاری رکھیں اور جیتتے رہیں! GoBuy—ہر روز خریداری کو خوشگوار اور فائدہ مند بنائیں!",
    "doubleBet.title": "بیٹنگ کا معجزہ｜3 آسان مراحل، الٹ کر بڑی انعامات جیتیں!",
    "doubleBet.step1": "مرحلہ 1: $1 زون منتخب کریں، $0.5 خریدیں، 5 یونٹ خریدیں اور جیتنے پر فوراً رک جائیں۔",
    "doubleBet.step2": "اگر نہیں جیتے، مرحلہ 2: $3 زون منتخب کریں، $1.5 خریدیں، 15 یونٹ خریدیں اور جیتنے پر فوراً رک جائیں۔",
    "doubleBet.step3": "اگر پھر بھی نہیں جیتے، مرحلہ 3: $8 زون منتخب کریں، $4 خریدیں، 40 یونٹ خریدیں اور جیتنے پر مبارک ہو۔",
    "doubleBet.step4": "جیتنے کے بعد، آپ پچھلے دو مراحل کے نقصانات کو پورا کر سکتے ہیں اور منافع کما سکتے ہیں، پھر دوبارہ مرحلہ 1 سے شروع کریں۔",
    "invite.reward4.title": "انعام 4: محدود وقت کے فوائد | نئے صارفین کے لیے خصوصی تحفے",
    "invite.reward4.step1": "1 خوش قسمت خریداری میں مفت شرکت",
    "invite.reward4.step2": "1 گمشدہ باکس لٹری کو مفت میں فعال کریں",
    "invite.reward4.step3": "مخصوص کام مکمل کریں اور اضافی $1 نقد انعام حاصل کریں",
    "reward.register.title": "رجسٹریشن انعام",
    "reward.register.point1": "نئے صارفین کو رجسٹریشن پر ایک مفت لکی بائے موقع ملے گا۔",
    "reward.register.point2": "رجسٹریشن کے بعد گروپ میں شامل ہو کر لال لفافے کی تقریب میں شامل ہوں۔",
    "reward.task.title": "ٹاسک انعام",
    "reward.task.point1": "بطور مہمان لاگ ان کریں اور ایک بلائنڈ باکس کھولیں۔",
    "reward.task.point2": "درج ذیل تین لکی بائے ٹاسک مکمل کریں، ہر زون میں ایک بار:",
    "reward.task.subtask1": "$1 زون: $0.5 خریدیں",
    "reward.task.subtask2": "$3 زون: $1.5 خریدیں",
    "reward.task.subtask3": "$8 زون: $4 خریدیں",
    "reward.task.point3": "دونوں ٹاسک مکمل کریں اور $1 انعام حاصل کریں!",
    "reward.share.title": "شیئرنگ انعام",
    "reward.share.desc": "میں نے ابھی GoBuy پر ایک سرپرائز بلائنڈ باکس اور ایک خوش قسمت قرعہ اندازی جیتی ہے!",
    "reward.share.desc3": "رجسٹریشن کے فوراً بعد میں خوش نصیب نکلا — کمال ہے!",
    "reward.share.desc4": "✨اپنی جیت کا اسکرین شاٹ شیئر کریں اور $1 انعام حاصل کریں۔",
    "reward.share.desc1": "10 دوستوں کو دعوت دیں اور ان کے رجسٹر ہونے پر $1 حاصل کریں۔ 1000 دعوتوں پر $100 کا انعام – کوئی حد نہیں، جتنی زیادہ دعوتیں، اتنا زیادہ انعام!",
    "reward.invite.title": "دعوتی انعام",
    "reward.invite.desc": "10 دوستوں کو کامیابی سے مدعو کریں اور ان کی رجسٹریشن مکمل کریں۔",
    "reward.share.desc2": "اوپر دیے گئے کام مکمل کریں اور شیئرنگ اور دعوتی انعامات حاصل کریں!",
    "reward.invite.desc1": "اوپر دیے گئے کام مکمل کریں اور دعوتی تقریب کا انعام حاصل کریں!",
}
export default en
